import { Col, Row, Tabs } from "antd";
import React from "react";
import './InvestorInformation.css'
import { NavLink } from "react-router-dom";
import { url } from "../../constants/navhome";
import AnnualReturns from "./AnnualReturns";
import PolicyStatutoryInfo from "./PolicyStatutoryInfo";

const InvestorInformation = () => {

  return (
    <>
      <img
        src="Sources/images/banner/investors-bg.jpeg"
        alt="404 -Not Given"
        className="about_img"
        // style={{ marginLeft: window.innerWidth > 1355 ? "5%" : "" }}
      />

      <section className="investorinformation mobile_margin">
        <div className="section_padding"></div>
        <div className="container">
          <div>
            <div>
              <p
                style={{ color: "#0d2e61" }}
                className="is-size-2 has-text-weight-semibold has-text-centered  mb-2"
              >
                Investor's Information
              </p>
            </div>
           
           <div>
              <Row>
                <Col
                  xxl={24}
                  lg={24}
                  md={24}
                  sm={24}
                  xs={24}
                  className="my-auto"
                >
                  <Tabs 
                    defaultActiveKey="1"
                    tabBarGutter={40}
                    className="investor-tabs"
                    items={[
                      {
                        key: "1",
                        label: "Extract of Annual Returns",
                        children: <AnnualReturns />
                      },
                      {
                        key: "2",
                        label: "Policies & other Statutory Information",
                        children: <PolicyStatutoryInfo />
                      }
                    ]}
                  >
                  </Tabs>
                </Col>
              </Row>  
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default InvestorInformation;
